import axios from 'axios';

/*
 * Only enabled in production or development. Make sure proxy is configured properly to route requests from REACT_APP_BASE_URL.
 * In local mode, Set REACT_APP_BASE_URL in package.json proxy property
 */
if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'development') {
	axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
}
// Automatically include cookies in Axios requests to ensure proper routing through the load balancer to the correct lio-server
axios.defaults.withCredentials = true

const post = async (url: string, dataObject: any, auth0IdToken: string | null) => {
	if (auth0IdToken !== null && auth0IdToken !== undefined) {
		return axios
			.post(url, dataObject, {
				headers: {
					Authorization: `Bearer ${auth0IdToken}`,
				},
			})
			.then((response) => {
				return response.data;
			})
	}
};

const postNoAuth = async (url: string, dataObject: any) => {
	return axios
		.post(url, dataObject, {})
		.then((response) => {
			return response.data;
		})
};

const get = async (url: string, auth0IdToken: string | null) => {
	if (auth0IdToken !== null && auth0IdToken !== undefined){
		return axios
			.get(url, {
				headers: {
					Authorization: `Bearer ${auth0IdToken}`,
				},
			})
			.then((response) => {
				return response.data;
			})
	}
};

export { post, postNoAuth, get };
